import { render, staticRenderFns } from "./manureLeft1.vue?vue&type=template&id=62cd079c&scoped=true&"
import script from "./manureLeft1.vue?vue&type=script&lang=js&"
export * from "./manureLeft1.vue?vue&type=script&lang=js&"
import style0 from "./manureLeft1.vue?vue&type=style&index=0&id=62cd079c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cd079c",
  null
  
)

export default component.exports